"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uint = exports.string = exports.bytes32 = exports.bytes = exports.bool = exports.address = void 0;
const uint = exports.uint = 'uint';
const address = exports.address = 'address';
const string = exports.string = 'string';
const bytes32 = exports.bytes32 = 'bytes32[]';
const bytes = exports.bytes = 'bytes';
const bool = exports.bool = 'bool';